import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
    name: 'safeResource',
    standalone: true,
})
export class SafeResourcePipe implements PipeTransform {

    public constructor(
        private readonly sanitizer: DomSanitizer,
    ) {
    }

    public transform(url: string | null): SafeResourceUrl | null {
        if (!url) return null;
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
